import { extendTheme } from "@chakra-ui/react";
import { globalStyles } from "./styles";
import { CardComponent } from "./additions/card/Card";
import { components } from "./components";

const config = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

export default extendTheme(
  { config },
  globalStyles,
  components,
  CardComponent,
);